/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Radio = require('backbone.radio');
var Ladda = require('ladda');

var BreadcrumbView = require('common/views/BreadcrumbView');

var eventDetailsForm = require('../../../event/views/COCEventDetailsView');
var SubmitEventFollowUpTask = require('../../services/SubmitEventFollowUpTask');

var tmplSubmitEventFollowupTaskView = require('./COCSubmitEventFollowupTaskTemplate.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplSubmitEventFollowupTaskView,

  className: 'coc-submit-event-followup-task-view container-fluid',

  ui: {
    breadcrumb: '.breadcrumb-container',
    eventDetailsContainer: '.event-details-container',
    submit: '.submit'
  },

  regions: {
    breadcrumb: '@ui.breadcrumb',
    eventDetailsContainer: '@ui.eventDetailsContainer'
  },

  behaviors: {
    TaskBehavior: {}
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#coc/dashboard',
            text: 'Home'
          },
          {
            text: 'Complete Event Follow-up'
          }
        ]
      })
    );
    this.model.set('isTaskView', true);
    this.showChildView('eventDetailsContainer', new eventDetailsForm({ model: this.model }));
  },

  validate: function() {
    return this.ui.eventDetailsContainer.parsley().whenValidate();
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);
    formData.taskId = this.model.get('taskId');
    formData.eventId = this.model.get('eventId');

    return formData;
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    this.validate().done(function() {
      var l = Ladda.create(self.ui.submit[0]);
      l.start();
      var formData = self.getFormData();
      SubmitEventFollowUpTask(formData)
        .done(function() {
          Radio.channel('navigate').trigger('show:int:coc:dashboard');
        })
        .fail(function() {
          l.stop();
        });
    });
  }
});
